import {
  PASSWORD_POLICY_START,
  PASSWORD_POLICY_DATA,
  PASSWORD_POLICY_UPSERT,
  PASSWORD_POLICY_DELETE,
  PASSWORD_POLICY_END,
} from "../type";
import { validateToken, redirectToLogin } from "../../../utils/auth/tokenValidation";

type Dispatch = (action: { type: string; payload?: any }) => void;

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => localStorage.getItem("loginToken");

export const getPasswordPolicy = () => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }
  try {
    dispatch({ type: PASSWORD_POLICY_START });
    const response = await fetch(`${API_URL}/api/password-policy/get`, {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: PASSWORD_POLICY_DATA, payload: res });
    } else {
      dispatch({ type: PASSWORD_POLICY_END, payload: res });
    }
  } catch (error) {
    dispatch({ type: PASSWORD_POLICY_END, payload: error });
  }
};

export const upsertPasswordPolicy = (data: any) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }
  try {
    dispatch({ type: PASSWORD_POLICY_START });
    const response = await fetch(`${API_URL}/api/password-policy/upsert`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
      body: JSON.stringify(data),
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: PASSWORD_POLICY_UPSERT, payload: res });
      return { success: true, data: res };
    } else {
      dispatch({ type: PASSWORD_POLICY_END, payload: res });
      return { success: false };
    }
  } catch (error) {
    dispatch({ type: PASSWORD_POLICY_END, payload: error });
    return { success: false };
  }
};

export const deletePasswordPolicy = () => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }
  try {
    dispatch({ type: PASSWORD_POLICY_START });
    const response = await fetch(`${API_URL}/api/password-policy`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: PASSWORD_POLICY_DELETE, payload: res });
      return { success: true };
    } else {
      dispatch({ type: PASSWORD_POLICY_END, payload: res });
      return { success: false };
    }
  } catch (error) {
    dispatch({ type: PASSWORD_POLICY_END, payload: error });
    return { success: false };
  }
};
